import React from "react";

import { ScreenFrame } from "components/onboarding/ScreenFrame";

const screenInfo = {
  title: "Atenção!",
  body: [
    "Para ter acesso à plataforma com todas funcionalidades, é importante que você preencha esses dados!",
    "Mas você pode preenchê-los em outro momento.",
  ],
  nextScreen: "/onboarding/monitoring",
  alternateScreen: "/onboarding/energy-operator",
  dashboardScreen: "/admin/billing",
  anchor: "Inserir dados de acesso à concessionária",
  buttonText: "Continuar",
};

const EnergyOperatorSkip = ({ history, location }) => {
  const handleButtonClick = () => {
    const returnToDashboard = location.state?.returnToDashboard;
    const { dashboardScreen, nextScreen } = screenInfo;

    returnToDashboard
      ? history.replace(dashboardScreen)
      : history.push(nextScreen);
  };
  return (
    <ScreenFrame
      anchorText={screenInfo.anchor}
      body={screenInfo.body}
      buttonText={screenInfo.buttonText}
      link={screenInfo.alternateScreen}
      onClick={handleButtonClick}
      title={screenInfo.title}
      variant="info"
    />
  );
};

export default EnergyOperatorSkip;
